"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const core_1 = require("@storex/core");
const useUpdate_1 = require("./useUpdate");
function useDispatcher(dis) {
    if (!(dis instanceof Array)) {
        dis = [dis];
    }
    const update = useUpdate_1.useUpdate();
    react_1.useEffect(() => {
        function _update() {
            update();
        }
        const r = dis;
        core_1.Dispatcher.register(_update, r);
        return () => {
            core_1.Dispatcher.unregister(_update, r);
        };
    }, []);
}
exports.useDispatcher = useDispatcher;
//# sourceMappingURL=useDispatcher.js.map